export const SearchIcon = ({ className = "" }: { className?: string }) => (
    <svg
        className={className}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
    >
        <circle
            cx="11"
            cy="11"
            r="8"
        />
        <line
            x1="21"
            x2="16.65"
            y1="21"
            y2="16.65"
        />
    </svg>
);
